import { useLocation, useNavigate } from 'react-router-dom'
import { appLink } from '@app/config/appLink'
import { useLayerDataFetcher } from '@app/components/Molecules/RiskSideDrawerContent/data_fetchers/layerDataFetcher'
import { workspaceHasNoValidLayers } from '@app/components/Risk/Workspaces/utils/Workspaces.utils'
import { RiskWorkspace } from '@app/types'
import { useLiveContext } from '@app/modules/Live/contexts/Live.Context'

export const useApplyWorkspace = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const layerData = useLayerDataFetcher()
  const { liveLayers } = useLiveContext()

  const applyWorkspace = (workspace: RiskWorkspace | null | undefined) => {
    if (!workspace || !layerData || workspaceHasNoValidLayers(workspace, layerData, liveLayers))
      return

    // Stays on the live map when applied from there, otherwise opens the risk map
    const basePath = pathname.startsWith(appLink.rexLive.path)
      ? appLink.rexLive.path
      : appLink.riskExplorer.path

    // loads the workspace from the useLoadWorkspaceFromURL hook on the risk/live page
    navigate(`${basePath}?workspace=${workspace.id}`)
  }

  return { applyWorkspace }
}
